import React from 'react'
import styles from './ResultsLabel.module.sass'
import useTrans from '@hooks/useTrans'

interface Props {
  num?: number
  tot?: number
  className?: string
}

const ResultsLabel = (props: Props) => {
  const { num = 0, tot = 0, className = '' } = props

  const t = useTrans()

  return (
    <p className={`${styles.root} ${className}`}>
      {t(num === 1 ? '{0} di {1} risultato' : '{0} di {1} risultati', [
        (num || 0).toString(),
        (tot || 0).toString(),
      ])}
    </p>
  )
}

export default ResultsLabel
